module.exports = __webpack_public_path__ + "static/media/google_02.2285b363.svg";